import {Pipe, PipeTransform} from "@angular/core";
import {Intervall, intervallerSomStreng} from "felles-ng2/typer/aksjenummer";

@Pipe({name: 'aksjenummerintervaller', pure: true, standalone: true})
export class AksjenummerintervallerPipe implements PipeTransform {
    transform(intervall: Intervall|Intervall[]): string | null {
        return intervallerSomStreng(intervall)
    }
}
